






import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from '../../fetchSetup';


const GoogleCallback = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const expectedRole = "admin"; 

  useEffect(() => {
    const handleGoogleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const errorParam = params.get("error");
      if (errorParam) {
        setError({ message: errorParam });
        setOpenDialog(true);
        return;
      }

      const token = params.get("token");
      const userId = params.get("user_id");
      const roleFromParams = params.get("role"); // role sent from backend

      if (!token || !userId) {
        navigate("/login");
        return;
      }

      // ✅ Check roleFromParams before fetching user
      if (expectedRole && roleFromParams !== expectedRole) {
        alert(`Role not matched: ${roleFromParams}. This is an Admin app.`);
        navigate("/login");
        return;
      }

      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userId", userId);

      try {
        const googleuserApiUrl = `${process.env.REACT_APP_GET_GOOGLE_USER_API}/${userId}`;
        const res = await apiRequest(googleuserApiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error("Failed to fetch user");

        const userData = await res.json();

        if (!userData || !userData.user) {
          setError({ message: "User not found" });
          setOpenDialog(true);
          navigate("/login");
          return;
        }

        setUser(userData.user);

        // Navigate based on role
        if (userData.user.role === "admin") navigate("/admin-dashboard");
        else navigate("/");

      } catch (err) {
        console.error("Error fetching user:", err);
        setError({ message: "Failed to fetch user" });
        setOpenDialog(true);
        navigate("/login");
      }
    };

    handleGoogleCallback();
  }, [navigate, expectedRole]);


};

export default GoogleCallback;
